module.exports = __webpack_public_path__ + "img/daycohost3.330bbc2a.png";